import createCache, { EmotionCache } from '@emotion/cache';

/**
 * Emotion style cache shared by the client and the SSR renderer (NOA-3189).
 *
 * `key` prefixes every generated class (`naf-…`) and the `data-emotion` attribute, keeping
 * Emotion's styles namespaced and distinct from the styled-components styles that coexist
 * during (and, for the `@naf/*` design-system packages, after) the migration.
 *
 * No `nonce` is set: the CSP `style-src` allows `'unsafe-inline'`, so injected `<style>`
 * tags aren't nonce-gated (scripts are — that's handled separately in the renderer).
 */
export const EMOTION_CACHE_KEY = 'naf';

export const createEmotionCache = (): EmotionCache => createCache({ key: EMOTION_CACHE_KEY });
